import state from './moduleProductState'
import actions from './moduleProductActions'
import getters from './moduleProductGetters'
import mutations from './moduleProductMutations'

export default {
    namespaced: true,
    isRegistered: false,

    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
}